import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './whenShop.css';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import { MdShoppingBag, MdLocalShipping, MdClose } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import ApiServiceHelper from '../../auth/apiServiceHelper';
import { useDispatch, useSelector } from 'react-redux';
import { setDeliveryDate, setDeliverySlot, setPickupDate, setPickupSlot } from '../../store/slices/cartSlice';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { WR } from '../../components/ui/tokens';

// VISUAL RELOOKING ONLY — same date/slot selection logic, same fetch calls,
// same handlers and navigation as before. Only the markup/styling changed.
const WhenShop = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const pickable_type = useSelector(state => state.cart.userInfo.pickable_type)
  const pickable_id = useSelector(state => state.cart.userInfo.pickable_id)

  const deliverable_type = useSelector(state => state.cart.userInfo.deliverable_type)
  const deliverable_id = useSelector(state => state.cart.userInfo.deliverable_id)

  const pickup_slot = useSelector(state => state.cart.userInfo.pickup_slot)
  const delivery_slot = useSelector(state => state.cart.userInfo.delivery_slot)

  const selectedShop = useSelector(state => state.cart.userInfo.selectedShop)
  const selectedAddress = useSelector(state => state.cart.userInfo.selectedAddress)
  const selectedPoint = useSelector(state => state.cart.userInfo.selectedPoint)

  const selectedShopDeliverable = useSelector(state => state.cart.userInfo.selectedShopDeliverable)
  const selectedAddressDeliverable = useSelector(state => state.cart.userInfo.selectedAddressDeliverable)
  const selectedPointDeliverable = useSelector(state => state.cart.userInfo.selectedPointDeliverable)

  const currentDate = new Date();

  const year = currentDate.getUTCFullYear();
  const month = ('0' + (currentDate.getUTCMonth() + 1)).slice(-2);
  const day = ('0' + currentDate.getUTCDate()).slice(-2);
  const formattedDate = `${year}-${month}-${day}`;

  const [pickupDate, setPickupDateState] = useState(formattedDate);
  const [deliveryDate, setDeliveryDateState] = useState(dayjs(pickupDate).add(7, 'day').format('YYYY-MM-DD'));
  const [pickupSlotData, setPickupSlotData] = useState([]);
  const [deliverySlotData, setDeliverySlotData] = useState([]);
  const [selectedPickupSlot, setSelectedPickupSlot] = useState(null);
  const [selectedDeliverySlot, setSelectedDeliverySlot] = useState(null);
  const [shiftError, setShiftError] = useState(false);
  const [sameDateError, setSameDateError] = useState(false);
  const [showPastPickupDateError, setShowPastePickupDateError] = useState(false);
  const [showPastDeliveryDateError, setShowPastDeliveryDateError] = useState(false);
  const [checkFirstLoad, setCheckFirstLoad] = useState(true)

  const accent = WR.color.brand;
  // Localize the calendar (month + weekday names) to the chosen UI language so
  // it reads "Juin / lun mar mer" in FR instead of the browser default.
  const lang = i18n.language || "";
  const calLocale =
    lang.startsWith("fr") || lang === "french"
      ? "fr-FR"
      : lang.startsWith("nl") || lang === "dutch"
      ? "nl-NL"
      : lang.startsWith("en") || lang === "english"
      ? "en-GB"
      : "fr-FR";

  const fetchSlots = (date, setSlotsData, pickable_type, pickable_id, deliverable_type, deliverable_id, pickupCheck = false, deliveryCheck = false) => {
    let url = `shop/available_slot?date=${date}`;

    if (pickable_type && pickable_id) {
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    }

    if (!deliverable_type && !deliverable_id) {
      // If deliverable_type and deliverable_id are null, fetch slots for both pickup and delivery
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    } else if (deliverable_type && deliverable_id) {
      url += `&deliverable_type=${deliverable_type}&deliverable_id=${deliverable_id}`;
    }
    ApiServiceHelper.getSlots(url)
      .then(response => {

        setSlotsData(response.data.slots);

        if (pickupCheck) {
          setSelectedPickupSlot(response.data.slots[0])
          dispatch(setPickupSlot(response.data.slots[0]))
        }

        if (deliveryCheck) {
          setSelectedDeliverySlot(response.data.slots[0]);
          dispatch(setDeliverySlot(response.data.slots[0]));
        }

      })
      .catch(error => {
        console.log(error, 'date error');
      });
  };

  const fetchWeekSlots = (date, setSlotsData, pickable_type, pickable_id, deliverable_type, deliverable_id) => {
    let url = `shop/available_slots?date=${date}`;

    if (pickable_type && pickable_id) {
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    }

    if (!deliverable_type && !deliverable_id) {
      // If deliverable_type and deliverable_id are null, fetch slots for both pickup and delivery
      url += `&collectable_type=${pickable_type}&collectable_id=${pickable_id}`;
    } else if (deliverable_type && deliverable_id) {
      url += `&deliverable_type=${deliverable_type}&deliverable_id=${deliverable_id}`;
    }
    ApiServiceHelper.getSlots(url)
      .then(response => {
        let firstSlot = checkPickupTime(response?.data?.dates)
        const defaultDeliveryTime = response?.data?.default_delivery_time
        if (firstSlot) {
          setPickupDateState(dayjs(response?.data?.first_pickup_slot?.date).format('YYYY-MM-DD'))
          dispatch(setPickupDate(dayjs(response?.data?.first_pickup_slot?.date).format('YYYY-MM-DD')));
          setSlotsData(firstSlot?.firstSlot?.slots);
          setDeliveryDateState(dayjs(response?.data?.first_delivery_slot?.date).format('YYYY-MM-DD'))
          dispatch(setDeliveryDate(dayjs(response?.data?.first_delivery_slot?.date).format('YYYY-MM-DD')));
          handlePickupSlotSelection(response?.data?.first_pickup_slot?.slots[0])

        }
      })
      .catch(error => {
        console.log(error, 'date error');
      });
  };

  const checkPickupTime = (slotsWithDates) => {
    let result = null;

    slotsWithDates.some((item) => {
      const currentDate = new Date();
      const currentHours = currentDate.getHours();
      const currentMinutes = currentDate.getMinutes();

      const slotDate = new Date(item.date);
      const isToday = currentDate.toDateString() === slotDate.toDateString();

      return item.slots.some((slot) => {
        const [start, end] = slot.split('-'); // Get the start time
        const [startHour, startMinute] = start.split(':').map(Number);
        const [endHour, endMinute] = end.split(':').map(Number);

        if (isToday) {
          // For today's slots, check if current time is before the start time
          const isAfterStart = currentHours > startHour || (currentHours === startHour && currentMinutes >= startMinute);
          const isBeforeEnd = currentHours < endHour || (currentHours === endHour && currentMinutes <= endMinute);
          if (isAfterStart && isBeforeEnd) {
            result = { firstSlot: item, slot: slot };
            return true; // Found a matching slot, break out of the loop
          }
        } else {
          // For future days, just pick the first available slot
          result = { firstSlot: item, slot: slot };
          return true; // Stop checking as soon as we find a slot on the next day
        }

        return false; // Continue to the next slot
      });
    });

    return result;
  };

  useEffect(() => {
    if (checkFirstLoad) {
      fetchWeekSlots(pickupDate, setPickupSlotData, pickable_type, pickable_id, deliverable_type, deliverable_id);
      setCheckFirstLoad(false)
    } else {
      fetchSlots(pickupDate, setPickupSlotData, pickable_type, pickable_id, deliverable_type, deliverable_id, true, false);
      dispatch(setPickupDate(pickupDate));
    }

  }, [pickupDate]);

  useEffect(() => {
    if (!deliverable_type && !deliverable_id) {
      // If deliverable_type and deliverable_id are null, use pickupSlotData for deliverySlotData
      setDeliverySlotData(pickupSlotData);
    } else {
      fetchSlots(deliveryDate, setDeliverySlotData, deliverable_type, deliverable_id, null, null, false, true);
      dispatch(setDeliveryDate(deliveryDate));
    }
  }, [deliveryDate, deliverable_type, deliverable_id, pickupSlotData]);


  useEffect(() => {
    if (pickupDate === deliveryDate) {
      setSameDateError(true)
    }
    if (pickupDate < formattedDate) {
      setShowPastePickupDateError(true);
    }
    if (deliveryDate < pickupDate) {
      setShowPastDeliveryDateError(true);
    }

    const timeout = setTimeout(() => {
      setSameDateError(false)
      setShowPastePickupDateError(false)
      setShowPastDeliveryDateError(false)
    }, 3000);

    return () => clearTimeout(timeout);

  }, [pickupDate, deliveryDate])

  const handleNavigate = () => {
    if (selectedPickupSlot || selectedDeliverySlot === null) {
      setShiftError(true)
    }
    if (delivery_slot && pickup_slot !== null) {
      navigate('/checkout');
    }
    setTimeout(() => {
      setShiftError(false)
    }, [3000]);
  };

  const handleNavigatePrevious = () => {
    navigate('/where')
  }

  const handlePickupSlotSelection = slot => {
    if (pickupDate < formattedDate) {
      setShowPastePickupDateError(true)
      setSelectedPickupSlot(null);
      dispatch(setPickupSlot(null));
    } else {
      setSelectedPickupSlot(slot)
      dispatch(setPickupSlot(slot))
    }
  };

  const handleDeliverySlotSelection = slot => {
    if (pickupDate === deliveryDate) {
      setSameDateError(true)
      setSelectedDeliverySlot(null);
      dispatch(setDeliverySlot(null));
    } else if (deliveryDate < pickupDate) {
      setShowPastDeliveryDateError(true)
      setSelectedDeliverySlot(null);
      dispatch(setDeliverySlot(null));
    } else {
      setSelectedDeliverySlot(slot);
      dispatch(setDeliverySlot(slot));
    }

    const timeout = setTimeout(() => {
      setSameDateError(false)
      setShowPastePickupDateError(false)
      setShowPastDeliveryDateError(false)
    }, 3000);

    return () => clearTimeout(timeout);

  };

  const handleClose = () => {
    setShiftError(false)
    setSameDateError(false)
    setShowPastDeliveryDateError(false)
  }

  // ---- presentational helpers (no behavior) ----
  const ready = pickup_slot && delivery_slot !== null;

  const cardStyle = {
    background: '#fff',
    borderRadius: 24,
    border: `1px solid ${WR.color.border}`,
    boxShadow: WR.shadow.card,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
  };

  const slotPill = (selected) => ({
    height: 42,
    padding: '0 16px',
    borderRadius: 12,
    border: `1.5px solid ${selected ? accent : WR.color.border}`,
    background: selected ? accent : '#fff',
    color: selected ? '#fff' : WR.color.encre,
    fontSize: 13.5,
    fontWeight: 700,
    cursor: 'pointer',
    transition: 'all .15s ease',
    boxShadow: selected ? WR.shadow.cta : 'none',
  });

  const CardHead = ({ icon, title, sub }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 36, height: 36, borderRadius: 12, background: WR.color.lavSel, color: accent, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </span>
        <span style={{ fontSize: 17, fontWeight: 800, color: WR.color.encre }}>{title}</span>
      </div>
      <span style={{ fontSize: 13, fontWeight: 700, color: WR.color.inkMuted }}>{sub}</span>
    </div>
  );

  const ErrorBanner = ({ children }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 12, background: '#FDECEC', border: '1px solid #F3C9CF', color: WR.color.danger, fontSize: 13, fontWeight: 600, marginBottom: 12 }}>
      <span style={{ flex: 1 }}>{children}</span>
      <button onClick={handleClose} style={{ border: 0, background: 'none', color: WR.color.danger, cursor: 'pointer', display: 'flex', padding: 0 }}>
        <MdClose size={16} />
      </button>
    </div>
  );

  // Delivery side uses the pickup slots when there's no separate deliverable
  // target (unchanged from before).
  const deliverySource = (deliverable_type === null && deliverable_id === null) ? pickupSlotData : deliverySlotData;

  const renderSlots = (data, selected, onSelect) =>
    [...data]
      .sort((a, b) => {
        // Extract the start time from each slot (e.g., '10:00-12:00' → '10')
        const getStartTime = (slot) => parseInt(slot.split(':')[0], 10);
        return getStartTime(a) - getStartTime(b);
      })
      .map(slot => {
        const [startTime, endTime] = slot.split(':00');
        const formattedSlot = `${startTime}h${endTime}h`;
        return (
          <button key={slot} style={slotPill(selected === slot)} onClick={() => onSelect(slot)}>
            {formattedSlot}
          </button>
        );
      });

  return (
    <>
      <Header />
      {/* No bottom padding: the sticky nav bar below carries its own, so it
          sits flush with the bottom of the viewport instead of floating above
          a strip of background once the page is scrolled to the end. */}
      <div style={{ background: WR.color.bg, minHeight: 'calc(100vh - 67px)', fontFamily: WR.font.sans, padding: 'clamp(24px,4vh,48px) clamp(16px,4vw,40px) 0' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              padding: '6px 13px',
              borderRadius: 999,
              background: 'rgba(61, 69, 134, 0.08)',
              color: accent,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: 1.5,
              textTransform: 'uppercase',
            }}
          >
            <span style={{ width: 7, height: 7, borderRadius: 999, background: accent }} />
            {t("DIRECTION_IN")} · {t("NEW_ORDER")}
          </div>
          <h1 style={{ fontSize: 'clamp(24px,3vw,32px)', fontWeight: 800, letterSpacing: -0.5, margin: '8px 0 26px', color: WR.color.encre }}>
            {t("SCHEDULE_TITLE")}
          </h1>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(360px,1fr))', gap: 24, alignItems: 'start' }}>
            {/* Pick-up card */}
            <div style={cardStyle}>
              <CardHead
                icon={<MdShoppingBag size={18} />}
                title={t("PICK_UP")}
                sub={selectedShop ? t('SHOP') : selectedAddress ? t('HOME') : selectedPoint ? 'Office' : '@Shop_name'}
              />
              <div className="wr-cal">
                <Calendar
                  onChange={(e) => {
                    setPickupDateState(dayjs(e).format("YYYY-MM-DD"))
                    setSelectedPickupSlot(null)
                    dispatch(setPickupSlot(null))
                    setSelectedPickupSlot(null);
                    dispatch(setPickupSlot(null));
                    setSelectedDeliverySlot(null);
                    dispatch(setDeliverySlot(null));
                  }}
                  value={pickupDate}
                  locale={calLocale}
                  calendarType="iso8601"
                />
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 18 }}>
                {renderSlots(pickupSlotData, selectedPickupSlot, handlePickupSlotSelection)}
              </div>
            </div>

            {/* Delivery card */}
            <div style={cardStyle}>
              <CardHead
                icon={<MdLocalShipping size={18} />}
                title={t("DELIVERY")}
                sub={selectedShopDeliverable ? t('SHOP') : selectedAddressDeliverable ? t('HOME') : selectedPointDeliverable ? 'Office' : selectedShop ? 'Shop' : selectedAddress ? 'Home' : selectedPoint ? 'Office' : '@Shop_name'}
              />
              {shiftError && <ErrorBanner>{t("PLEASE_SELECT_SHIFT")}</ErrorBanner>}
              {showPastDeliveryDateError && <ErrorBanner>{t("DELIVERY_CANT_BE_BEFORE_PICKUP")}</ErrorBanner>}
              {showPastPickupDateError && <ErrorBanner>{t("PICKUP_CANT_BE_BEFORE_TODAY")}.</ErrorBanner>}
              {sameDateError && <ErrorBanner>{t("DELIVERY_CANT_BE_ON_SAME_DAY")}</ErrorBanner>}
              <div className="wr-cal">
                <Calendar
                  onChange={(e) => {
                    setDeliveryDateState(dayjs(e).format('YYYY-MM-DD'))
                    setSelectedDeliverySlot(null)
                    dispatch(setDeliverySlot(null))
                  }}
                  value={deliveryDate}
                  locale={calLocale}
                  calendarType="iso8601"
                />
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 18 }}>
                {renderSlots(deliverySource, selectedDeliverySlot, handleDeliverySlotSelection)}
              </div>
            </div>
          </div>

          {/* Footer nav — sticky to the bottom of the viewport. Two calendars
              plus their slot pills run past the fold on the counter's screen,
              which left Previous/Next off-screen: the operator had to scroll
              down every time just to move on. */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 16,
              marginTop: 32,
              position: 'sticky',
              bottom: 0,
              zIndex: 5,
              padding: '14px 0 clamp(16px,3vh,28px)',
              background: WR.color.bg,
              borderTop: `1px solid ${WR.color.border}`,
            }}
          >
            <button
              onClick={handleNavigatePrevious}
              style={{ height: 52, padding: '0 28px', borderRadius: 999, background: WR.color.lavSoft, color: WR.color.brand, border: `1px solid ${WR.color.border}`, fontSize: 14, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
            >
              <GoArrowLeft size={18} />
              {t("PREVIOUS")}
            </button>
            <button
              onClick={handleNavigate}
              style={{
                height: 56,
                padding: '0 46px',
                borderRadius: 999,
                background: ready ? accent : 'rgba(61, 69, 134, 0.22)',
                color: ready ? '#fff' : 'rgba(0,0,0,0.45)',
                border: 0,
                fontSize: 16,
                fontWeight: 700,
                boxShadow: ready ? WR.shadow.cta : 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer',
              }}
            >
              {t("NEXT")}
              <GoArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhenShop;
